// ─────────────────────────────────────────────────────────────────────
// <SMark /> — the italic gold "S" glyph (S-mark addendum, 30 Apr 2026: the assistant is S — Showz / Saartee;
// the butterfly centre and the wordmark keep their N)
//
// Used in:
//   - <AskSFab /> floating button
//   - inline editorial accent
//   - splash/loading
//
// Sizes: 'xs' | 'sm' | 'md' | 'lg' | number
// pulse:  shows a pulsing ring (used on FAB)
// ─────────────────────────────────────────────────────────────────────

const SIZE = {
  xs: 18,
  sm: 24,
  md: 36,
  lg: 56,
};

export default function SMark({
  size = 'md',
  pulse = false,
  className = '',
  glow = false,
}) {
  const px = typeof size === 'number' ? size : (SIZE[size] || SIZE.md);

  return (
    <span
      className={`relative inline-flex items-center justify-center select-none ${className}`}
      style={{
        width: px,
        height: px,
        borderRadius: '50%',
        background: 'var(--snt-accent)',
        color: 'var(--snt-accent-fg)',
        fontFamily: 'var(--font-serif, "Fraunces")',
        fontStyle: 'italic',
        fontWeight: 600,
        fontSize: px * 0.55,
        lineHeight: 1,
        boxShadow: glow ? '0 4px 18px rgba(212,165,116,0.5)' : 'none',
        transition: 'box-shadow 250ms',
      }}
      aria-hidden="true"
      data-glyph="S"
    >
      S
      {pulse && (
        <span
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{
            border: '2px solid var(--snt-accent)',
            animation: 'snt-pulse 2.4s ease-out infinite',
          }}
        />
      )}
      <style>{`
        @keyframes snt-pulse {
          0%   { transform: scale(1);   opacity: 0.6; }
          80%  { transform: scale(1.6); opacity: 0;   }
          100% { transform: scale(1.6); opacity: 0;   }
        }
      `}</style>
    </span>
  );
}
